//@ts-nocheck
import React, { useEffect, useState } from "react";
import JobExperienceSection from "../JobExperienceSection";
import JobEducationSection from "../JobEducationSection";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  fetchApplicationByDetails,
  UpdateJobApplicationByListForApplication,
} from "../../../features/ApplicationData/ApplicationDataSlice";
import { toast } from "sonner";
import { _baseRequest, COMMON } from "../../../utils/baseApi";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { CrossIcon, ChevronDownIcon } from "../../icons/Icons";
import SkillsInput from "../../common/SkillsInput";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
  Switch,
  Transition,
} from "@headlessui/react";
import JobWorkplaceTypeListbox from "../JobWorkplaceTypeListbox";
import JobEduLocationModal from "../JobEduLocationModal";

const months = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

const years = Array.from({ length: 30 }, (_, i) => {
  const year = (2025 - i).toString();
  return { value: year, label: year };
});

const CustomDropdown = ({
  label,
  value,
  onChange,
  options,
  name,
  placeholder = "Select...",
}) => {
  const selectedOption = options.find((opt) => opt.value === value);

  const handleChange = (newValue) => {
    onChange({
      target: {
        name: name,
        value: newValue,
      },
    });
  };

  return (
    <div className="grid gap-[6px]">
      {label && (
        <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
          {label}
        </label>
      )}
      <Listbox value={value} onChange={handleChange}>
        <div className="relative">
          <Listbox.Button className="relative w-full cursor-pointer rounded-lg bg-white py-[5px] pl-3 pr-10 text-left border border-gray-200 focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2">
            <span
              className={`block truncate text-[14px] ${
                !selectedOption ? "text-gray-400" : "text-gray-900"
              }`}
            >
              {selectedOption ? selectedOption.label : placeholder}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronDownIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={React.Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute overflow-auto h-[150px] z-10 mt-[9px] left-[0px] bg-white max-w-[100%] min-w-[100%] w-full rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
              {options.map((option) => (
                <Listbox.Option
                  key={option.value}
                  value={option.value}
                  className={({ active, selected }) =>
                    `relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 ${
                      active ? "bg-gray-200 text-[#1d2025]" : "text-gray-900"
                    }`
                  }
                >
                  {({ selected }) => (
                    <span
                      className={`block truncate text-[14px] ${
                        selected ? "font-medium" : "font-normal"
                      }`}
                    >
                      {option.label}
                    </span>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
};

const renderFormattedSummary = (summary) => {
  try {
    // Try to parse the summary as JSON
    const parsed = JSON.parse(summary);

    return (
      <div className="space-y-3">
        {parsed.highlight && (
          <div>
            <p className="font-medium mb-1">Highlight:</p>
            <ul className="list-disc pl-5">
              {Array.isArray(parsed.highlight) ? (
                parsed.highlight.map((item, index) => (
                  <li key={index}>{item}</li>
                ))
              ) : (
                <li>{parsed.highlight}</li>
              )}
            </ul>
          </div>
        )}

        {parsed.strengths && (
          <div>
            <p className="font-medium mb-1">Strengths:</p>
            <ul className="list-disc pl-5">
              {parsed.strengths.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        )}

        {parsed.weaknesses && (
          <div>
            <p className="font-medium mb-1">Weaknesses:</p>
            <ul className="list-disc pl-5">
              {parsed.weaknesses.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  } catch (e) {
    // If it's not JSON, return the raw text
    return <p>{summary}</p>;
  }
};

function ReviewOverview({
  applicationDetails,
  setapplicationDetails,
  isConductReview,
  setIsTrue,
  isTrue,
}: any) {
  const [jobRequirement, setJobRequirement] = useState("");
  const [jobRequirementLoading, setJobRequirementLoading] = useState("");
  const userDetailsData = localStorage.getItem("jobByHiringTeamMembers");
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];
  const [userId, setUserId] = useState(null);
  const [jobRequirementLoading1, setJobRequirementLoading1] = useState(false);
  const [loadingStates, setLoadingStates] = useState({});
  const [changeLayoutTab, setChangeLayoutTab] = useState(false);
  const [isSkillModalOpen, setIsSkillModalOpen] = useState(false);
  const [isSkillLoading, setIsSkillLoading] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const locations = useAppSelector((state) => state.location.locationDetails);
  const { baseId, jobId, applicationId } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
  }>();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [applicationResponse, setApplicationResponse] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [applicationResponseLoading, setApplicationResponseLoading] =
    useState(false);
  const [workplaceType, setWorkplaceType] = useState("");
  const [newExperienceForm, setNewExperienceForm] = useState({
    company: "",
    designation: "",
    startDateMonth: "",
    startDateYear: "",
    endDateMonth: "",
    endDateYear: "",
    location: "",
    workplaceType: "",
    isCurrentJob: false,
    description: "",
  });

  const [newEducationForm, setNewEducationForm] = useState({
    course: "",
    university: "",
    start_month: "",
    start_year: "",
    end_month: "",
    end_year: "",
    location: "",
    branch: "",
    grade: "",
    description: "",
  });

  const [isModalOpenEdu, setIsModalOpenEdu] = useState(false);
  const [isLoadingEdu, setIsLoadingEdu] = useState(false);
  const [workplaceTypeEdu, setWorkplaceTypeEdu] = useState("");
  const [loadingLocationEdu, setLoadingLocationEdu] = useState(false);
  const [selectedCountryEdu, setSelectedCountryEdu] = useState(null);

  const handleAddSkills = () => {
    // Use the existing parseSkills function instead of trying to JSON.parse directly
    const parsedSkills = parseSkills(applicationDetails?.application?.skills);

    setSelectedSkills(parsedSkills); // this ensures SkillsInput receives correct data
    setIsSkillModalOpen(true);
  };

  const handleSkillsChange = (skills) => {
    setSelectedSkills(skills);
  };

  const handleSubmitSkills = async () => {
    setIsSkillLoading(true);

    if (!selectedSkills || selectedSkills.length === 0) {
      toast.error("Please select at least one skill.");
      setIsSkillLoading(false);
      return;
    }

    try {
      const updatedSkills = {
        skills: selectedSkills,
      };
      const payload = {
        baseId,
        applicationId: applicationId || applicationDetails?.application?.id,
        skills: JSON.stringify(updatedSkills),
      };

      const response = await dispatch(
        UpdateJobApplicationByListForApplication(payload),
      ).unwrap();

      if (response.status === 200) {
        toast.success("Skills added successfully");

        const res = await dispatch(
          fetchApplicationByDetails({
            baseId: Number(baseId),
            jobId,
            applicationId: applicationId || applicationDetails?.application?.id,
          }),
        ).unwrap();

        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }

        setIsSkillModalOpen(false);
      }
    } catch (error) {
      console.error("Failed to add skills:", error);
      toast.error("Failed to add skills");
    } finally {
      setIsSkillLoading(false);
    }
  };

  const parseSkills = (skills) => {
    if (!skills) return [];
    if (Array.isArray(skills)) return skills;

    try {
      // First try to parse as JSON
      const parsed = JSON.parse(skills);
      return Array.isArray(parsed) ? parsed : parsed.skills || [];
    } catch {
      // If JSON parsing fails, treat as comma-separated string
      return typeof skills === "string"
        ? skills
            .split(",")
            .map((skill) => skill.trim())
            .filter((skill) => skill.length > 0)
        : [];
    }
  };

  // job requirment list rating
  useEffect(() => {
    const fetchInitialData = async () => {
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${applicationId || applicationDetails?.application?.id}/jobRequirement.listAppRatings`;

      try {
        setJobRequirementLoading(true);
        const response = await _baseRequest(fullUrl, "GET");

        if (response.status === 200) {
          setJobRequirement(response?.data);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setJobRequirementLoading(false);
      }
    };

    if (applicationId || applicationDetails?.application?.id) {
      fetchInitialData();
    }
  }, [applicationId, applicationDetails?.application?.id]);

  useEffect(() => {
    const storedUserDetails = JSON.parse(
      localStorage.getItem("userDetails") || "{}",
    );
    setUserId(storedUserDetails?.id); // Assuming the user ID is stored as 'id' in userDetails
  }, []);

  const hasUserRated = (userIds, currentUserId) => {
    if (!userIds || !currentUserId) {
      return false;
    }

    const userIdArray = userIds
      .toString()
      .split(",")
      .map((id) => id.trim());
    return userIdArray.includes(currentUserId.toString());
  };

  // const getBackgroundClasses = (userIds, currentUserId) => {

  //   const hasRated = hasUserRated(userIds, currentUserId);
  //   return hasRated
  //     ? 'bg-green-100 border-breen-200 text-gray-600 ring-green-500/10 ring-1 ring-inset'
  //     : 'bg-gray-50 ring-1 ring-inset ring-gray-500/10 text-gray-600';
  // };

  // Updated function to handle different background colors for Yes, Maybe, No
  const getBackgroundClasses = (userIds, currentUserId, ratingType) => {
    const hasRated = hasUserRated(userIds, currentUserId);

    if (!hasRated) {
      return "bg-gray-50 ring-1 ring-inset ring-gray-500/10 text-gray-600";
    }

    // Different colors based on rating type
    switch (ratingType) {
      case "yes":
        return "bg-[#f0fdf4] border-green-200 text-[#008236] ring-green-600/20 ring-1 ring-inset";
      case "maybe":
        return "bg-[#fefce8] border-yellow-200 text-[#894b00] ring-yellow-600/20 ring-1 ring-inset";
      case "no":
        return "bg-[#fef2f2] border-red-200 text-[#c10007] ring-red-600/20 ring-1 ring-inset";
      default:
        return "bg-[#fbf9fa] border-gray-200 text-[#4a5565] ring-gray-600/20 ring-1 ring-inset";
    }
  };

  const getUserProfileImage = (userId) => {
    const user = baseMembers.find(
      (member) =>
        member.user_id === userId || member.user_id === Number(userId),
    );
    return user ? user.profile_pic : `User ${userId}`;
  };

  const getUserName = (userId) => {
    const user = baseMembers.find(
      (member) =>
        member.user_id === userId || member.user_id === Number(userId),
    );
    return user ? user.name : `User ${userId}`;
  };

  const getAllUserImages = (userIds) => {
    if (!userIds) return [];

    const userIdArray = userIds
      .toString()
      .split(",")
      .map((id) => Number(id.trim()));

    return userIdArray.map((userId) => {
      const user = baseMembers.find(
        (member) =>
          member.user_id === userId || member.user_id === Number(userId),
      );
      return {
        id: userId,
        name: user ? user.name : `AI`,
        profile_pic: user ? user.profile_pic : null,
        isAI: !user,
      };
    });
  };

  // Helper function to set loading state for specific job and button type
  const setJobLoading = (jobId, buttonType, isLoading) => {
    setLoadingStates((prev) => ({
      ...prev,
      [`${jobId}_${buttonType}`]: isLoading,
    }));
  };

  // Helper function to get loading state for specific job and button type
  const getJobLoading = (jobId, buttonType) => {
    return loadingStates[`${jobId}_${buttonType}`] || false;
  };

  const handleAddRating = async (data) => {
    try {
      setJobLoading(data.id, "yes", true);

      const addRatingUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${data?.id}/jobRequirement.addRating`;
      const payload = {
        base_id: Number(baseId),
        job_id: jobId,
        app_id: applicationId || applicationDetails?.application?.id,
        yes_user_ids: userId.toString(),
      };

      const response = await _baseRequest(addRatingUrl, "POST", payload);
      if (response.status === 200) {
        toast.success("Rating added successfully!");
        // Call fetchInitialData after successful rating addition
        await fetchInitialData();
      }
    } catch (error) {
      console.error("Error adding rating:", error);
    } finally {
      setJobLoading(data.id, "yes", false);
    }
  };

  const handleAddRatingMaybe = async (data) => {
    try {
      setJobLoading(data.id, "maybe", true);

      const addRatingUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${data?.id}/jobRequirement.addRating`;
      const payload = {
        base_id: Number(baseId),
        job_id: jobId,
        app_id: applicationId || applicationDetails?.application?.id,
        maybe_user_ids: userId.toString(),
      };

      const response = await _baseRequest(addRatingUrl, "POST", payload);
      if (response.status === 200) {
        toast.success("Rating added successfully!");
        // Call fetchInitialData after successful rating addition
        await fetchInitialData();
      }
    } catch (error) {
      console.error("Error adding rating:", error);
    } finally {
      setJobLoading(data.id, "maybe", false);
    }
  };

  const handleAddRatingNo = async (data) => {
    try {
      setJobLoading(data.id, "no", true);

      const addRatingUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${data?.id}/jobRequirement.addRating`;
      const payload = {
        base_id: Number(baseId),
        job_id: jobId,
        app_id: applicationId || applicationDetails?.application?.id,
        no_user_ids: userId.toString(),
      };

      const response = await _baseRequest(addRatingUrl, "POST", payload);
      if (response.status === 200) {
        toast.success("Rating added successfully!");
        // Call fetchInitialData after successful rating addition
        await fetchInitialData();
      }
    } catch (error) {
      console.error("Error adding rating:", error);
    } finally {
      setJobLoading(data.id, "no", false);
    }
  };

  // Extracted fetchInitialData function
  const fetchInitialData = async () => {
    const listRatingsUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${applicationId || applicationDetails?.application?.id}/jobRequirement.listAppRatings`;

    try {
      setJobRequirementLoading(true);
      const response = await _baseRequest(listRatingsUrl, "GET");

      if (response.status === 200) {
        setJobRequirement(response?.data);
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      setJobRequirementLoading(false);
    }
  };

  const handleAddExperience = () => {
    setNewExperienceForm({
      company: "",
      designation: "",
      startDateMonth: "",
      startDateYear: "",
      endDateMonth: "",
      endDateYear: "",
      location: "",
      workplaceType: "",
      isCurrentJob: false,
      description: "",
    });
    setWorkplaceType("");
    setSelectedCountry(null);
    setIsModalOpen(true);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewExperienceForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleWorkplaceTypeChange = (value) => {
    setWorkplaceType(value);
    setNewExperienceForm((prev) => ({
      ...prev,
      workplaceType: value,
    }));
  };

  const handleLocationChange = (item) => {
    setSelectedCountry(item);
    setNewExperienceForm((prev) => ({
      ...prev,
      location: item.locationName,
    }));
  };

  const parseWorkExperience = (workString) => {
    try {
      const parsedData = JSON.parse(workString);

      return {
        ...parsedData,
        work_experience:
          parsedData.work_experience?.filter((work) => work !== null) || [],
      };
    } catch (e) {
      console.error("Error parsing work experience data:", e);
      return { work_experience: [] };
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      if (
        !newExperienceForm.company ||
        newExperienceForm.company.trim() === ""
      ) {
        toast.error("Company is required");
        setIsLoading(false);
        return;
      }
      if (
        !newExperienceForm.designation ||
        newExperienceForm.designation.trim() === ""
      ) {
        toast.error("Designation is required");
        setIsLoading(false);
        return;
      }
      const existingWorkExperience = applicationDetails.application?.app_work
        ? parseWorkExperience(applicationDetails.application.app_work)
        : { work_experience: [] };

      // Create new work experience entry
      const newWorkExperience = {
        company: newExperienceForm.company,
        designation: newExperienceForm.designation,
        startDateMonth: newExperienceForm.startDateMonth,
        startDateYear: newExperienceForm.startDateYear,
        endDateMonth: newExperienceForm.endDateMonth,
        endDateYear: newExperienceForm.endDateYear,
        location: newExperienceForm.location,
        workplace_type: newExperienceForm.workplaceType,
        isCurrentJob: newExperienceForm.isCurrentJob.toString(),
        description: newExperienceForm.description,
      };

      // Add new experience to the array
      const updatedWorkExperience = {
        ...existingWorkExperience,
        work_experience: [
          ...existingWorkExperience.work_experience,
          newWorkExperience,
        ],
      };
      const payload = {
        baseId,
        applicationId:applicationId || applicationDetails?.application?.id,
        app_work: JSON.stringify(updatedWorkExperience),
      };

      const response = await dispatch(
        UpdateJobApplicationByListForApplication(payload),
      ).unwrap();

      if (response.status === 200) {
        toast.success("Work experience added successfully");
        const res = await dispatch(
          fetchApplicationByDetails({
            baseId: Number(baseId),
            jobId: jobId,
            applicationId: applicationId || applicationDetails?.application?.id,
          }),
        ).unwrap();

        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Failed to add work experience:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChangeEducation = (e) => {
    const { name, value } = e.target;
    setNewEducationForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLocationChangeEdu = (item) => {
    setSelectedCountryEdu(item);
    setNewEducationForm((prev) => ({
      ...prev,
      location: item.locationName,
    }));
  };

  const parseEducation = (eduString) => {
    try {
      const parsedData = JSON.parse(eduString);
      return {
        ...parsedData,
        education_details:
          parsedData.education_details?.filter((edu) => edu !== null) || [],
      };
    } catch (e) {
      console.error("Error parsing education data:", e);
      return { education_details: [] };
    }
  };

  const handleSubmitEdution = async () => {
    setIsLoadingEdu(true);
    try {
      if (!newEducationForm.course || newEducationForm.course.trim() === "") {
        toast.error("Course is required");
        setIsLoadingEdu(false);
        return;
      }

      const exitingEducation = applicationDetails.application?.app_education
        ? parseEducation(applicationDetails.application.app_education)
        : { education_details: [] };

      // Create new education entry
      const newEducation = {
        course: newEducationForm.course,
        university: newEducationForm.university,
        start_month: newEducationForm.start_month,
        start_year: newEducationForm.start_year,
        end_month: newEducationForm.end_month,
        end_year: newEducationForm.end_year,
        location: newEducationForm.location,
        branch: newEducationForm.branch,
        grade: newEducationForm.grade,
        description: newEducationForm.description,
      };

      // Add new education to the array
      const updatedEducation = {
        ...exitingEducation,
        education_details: [
          ...exitingEducation.education_details,
          newEducation,
        ],
      };

      const payload = {
        baseId,
        applicationId:applicationId || applicationDetails?.application?.id,
        app_education: JSON.stringify(updatedEducation),
      };

      const response = await dispatch(
        UpdateJobApplicationByListForApplication(payload),
      ).unwrap();

      if (response.status === 200) {
        toast.success("Education added successfully");
        const res = await dispatch(
          fetchApplicationByDetails({
            baseId: Number(baseId),
            jobId: jobId,
            applicationId: applicationId || applicationDetails?.application?.id,
          }),
        ).unwrap();

        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }
        setIsModalOpenEdu(false);
      }
    } catch (error) {
      console.error("Failed to add education:", error);
    } finally {
      setIsLoadingEdu(false);
    }
  };

  const handleAddEducation = () => {
    setNewEducationForm({
      course: "",
      university: "",
      start_month: "",
      start_year: "",
      end_month: "",
      end_year: "",
      location: "",
      branch: "",
      grade: "",
      description: "",
    });
    setSelectedCountryEdu(null);
    setIsModalOpenEdu(true);
  };

  return (
    <>
      <div className="flex-1 flex flex-col h-full pt-2 pb-8">
        <div className="w-full flex justify-center">
          <div className="w-full">
            {applicationDetails?.application?.ai_summary && (
              <div className="bg-[#ffeab6] p-5 rounded-xl mt-0 mb-8">
                <div className="flex items-center gap-[6px] mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                    data-slot="icon"
                    className="w-4 h-4 text-[#0000007a]"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                    />
                  </svg>

                  <p className="text-[13px] leading-4 text-[#0000007a] font-medium uppercase">
                    AI Summary
                  </p>
                </div>
                <div className="text-[14px] text-[#000000eb] font-normal">
                  {renderFormattedSummary(
                    applicationDetails?.application?.ai_summary,
                  )}
                </div>
              </div>
            )}
            {applicationDetails?.application?.ai_summary && (
              <div className="bg-[#ededed] h-[1px] w-full my-8"></div>
            )}

            {applicationDetails?.application?.app_summary && (
              <div>
                <div className="flex items-center mb-5 gap-x-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                    data-slot="icon"
                    className="w-4 h-4 text-dark-black-200 "
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                    />
                  </svg>
                  <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                    Summary
                  </span>
                </div>

                {applicationDetails?.application?.app_summary}
              </div>
            )}
            {applicationDetails?.application?.app_summary && (
              <hr className="my-8"></hr>
            )}

            {applicationDetails?.application?.app_work && (
              <div className="mt-5">
                <div className="flex items-center justify-between mb-5 gap-x-3">
                  <div className="flex items-center gap-x-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-briefcase-2 w-[1rem] h-[1rem] text-[#808080]"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M3 9a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9z" />
                      <path d="M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2" />
                    </svg>

                    <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                      Experience 
                    </span>
                  </div>
                  <div
                    className="table-tooltip before:!bottom-[-32px] before:!left-[17px]"
                    data-title="Add Experience"
                  >
                    <button
                      type="button"
                      onClick={handleAddExperience}
                      className="relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm
                 font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none
                  disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 border
                 border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-6 w-6 "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-plus w-[0.9rem] h-[0.9rem] text-[#808080]"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M12 5l0 14" />
                        <path d="M5 12l14 0" />
                      </svg>
                    </button>
                  </div>
                </div>
                <JobExperienceSection
                  experienceData={applicationDetails.application.app_work}
                  setapplicationDetails={setapplicationDetails}
                  isConductReview={isConductReview}
                  isTrue={isTrue}
                  setIsTrue={setIsTrue}
                  applicationIdByParent={applicationId || applicationDetails?.application?.id}
                />
              </div>
            )}

            {applicationDetails?.application?.app_education && (
              <>
                <hr className="mt-6 mb-8"></hr>
                <div className="mt-5">
                  <div className="flex items-center justify-between mb-5 gap-x-3">
                    <div className="flex items-center gap-x-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-vocabulary w-[0.9rem] h-[0.9rem] text-[#808080]"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M10 19h-6a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h6a2 2 0 0 1 2 2a2 2 0 0 1 2 -2h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2z" />
                        <path d="M12 5v16" />
                        <path d="M7 7h1" />
                        <path d="M7 11h1" />
                        <path d="M16 7h1" />
                        <path d="M16 11h1" />
                        <path d="M16 15h1" />
                      </svg>
                      <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                        Education
                      </span>
                    </div>
                    <div
                      className="table-tooltip before:!bottom-[-32px] before:!left-[17px]"
                      data-title="Add Education"
                    >
                      <button
                        type="button"
                        onClick={handleAddEducation}
                        className="relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm
                 font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none
                  disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 border
                 border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-6 w-6 "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-plus w-[1rem] h-[1rem] text-[#808080]"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M12 5l0 14" />
                          <path d="M5 12l14 0" />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <JobEducationSection
                    educationData={applicationDetails.application.app_education}
                    setapplicationDetails={setapplicationDetails}
                    isConductReview={isConductReview}
                    applicationIdByParent={applicationId || applicationDetails?.application?.id}
                  />
                </div>
              </>
            )}
            <hr className="mt-6 mb-8"></hr>
            <div className="mb-5 gap-x-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-x-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icons-tabler-outline icon-tabler-bulb w-[1.1rem] h-[1.1rem] text-[#808080]"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7" />
                    <path d="M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3" />
                    <path d="M9.7 17l4.6 0" />
                  </svg>

                  <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                    Skills
                  </span>
                </div>
                <div
                  className="table-tooltip before:!bottom-[-32px] before:!left-[17px]"
                  data-title="Add skills"
                >
                  <button
                    type="button"
                    onClick={handleAddSkills}
                    className="relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm
                                          font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none
                                          disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 border
                                          border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-6 w-6"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-plus w-[0.9rem] h-[0.9rem] text-[#808080]"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M12 5l0 14" />
                      <path d="M5 12l14 0" />
                    </svg>
                  </button>
                </div>
              </div>
              <div className="flex items-center gap-2 mt-5 flex-wrap">
                {parseSkills(applicationDetails.application?.skills).map(
                  (skill, index) => (
                    <div
                      key={index}
                      className="flex items-start w-fit bg-blue-100 text-blue-800 text-sm px-2 py-1 rounded-md"
                    >
                      {skill.trim()}
                    </div>
                  ),
                )}
              </div>
            </div>

            {applicationResponseLoading ? (
              <div className="flex items-center justify-center h-[calc(50vh_-_56px)] w-full bg-white">
                <div className="simple-spinner-loader">
                  <span></span>
                </div>
              </div>
            ) : (
              <>
                {applicationResponse?.length > 0 && (
                  <>
                    <div className="bg-[#e0e0e0] w-full h-[1px] mt-7 mb-8"></div>

                    <div className="flex items-center gap-x-3 mb-7">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-library w-[1rem] h-[1rem] text-[#808080]"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M7 3m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
                        <path d="M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1" />
                        <path d="M11 7h5" />
                        <path d="M11 10h6" />
                        <path d="M11 13h3" />
                      </svg>
                      <span className="font-medium text-dark-black-200 mr-1 text-[15px] flex items-center gap-[6px]">
                        Application responses
                      </span>
                    </div>

                    <ul className="space-y-4">
                      {applicationResponse &&
                        applicationResponse.map((question, index) => (
                          <li
                            key={question.id}
                            className="relative flex gap-x-4"
                          >
                            <div className="relative flex-none w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center">
                              <span className="text-xs font-medium text-gray-700">
                                {question.question_order}
                              </span>
                            </div>
                            <div className="flex-auto rounded-md p-4 ring-1 ring-inset ring-gray-200">
                              <div className="w-full flex flex-col gap-2">
                                <div className="flex items-center">
                                  <div className="flex-1">
                                    <div className="flex flex-col gap-y-1">
                                      <div className="flex items-center gap-x-1">
                                        <span className="font-normal text-[#374151] text-[14px] wg-antialiased leading-4">
                                          {question.question_title}
                                        </span>
                                      </div>
                                      <div className="bg-gray-200 w-full h-px my-2"></div>
                                      <div className="flex flex-col gap-1">
                                        <span className="text-[0.8125rem] font-medium leading-4 text-[#1b1b1b] capitalize">
                                          {question.answer || "-"}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {/* skills */}
      <Dialog
        open={isSkillModalOpen}
        onClose={setIsSkillModalOpen}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <h3 className="text-base font-semibold leading-6 text-gray-900">
                Add New Skills
              </h3>
              <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setIsSkillModalOpen(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon aria-hidden="true" className="size-6" />
                </button>
              </div>
              <div className="space-y-2 md:space-y-4 lg:space-y-4">
                <SkillsInput
                  value={selectedSkills}
                  onChange={setSelectedSkills}
                />
              </div>

              <div className="flex justify-end gap-2 mt-5">
                <button
                  className="rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  onClick={() => setIsSkillModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmitSkills}
                  className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  <div className="flex items-center gap-[6px]">
                    Save
                    {isSkillLoading && (
                      <div className="simple-spinner">
                        <span></span>
                      </div>
                    )}
                  </div>
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      {/* experience  */}
      <Dialog
        open={isModalOpen}
        onClose={setIsModalOpen}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <h3 className="text-base font-semibold leading-6 text-gray-900">
                Add New Experience
              </h3>
              <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon aria-hidden="true" className="size-6" />
                </button>
              </div>
              <div className="grid gap-4 py-4 mt-1">
                <div className="grid gap-[6px]">
                  <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                    Company <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="company"
                    value={newExperienceForm.company}
                    onChange={handleInputChange}
                    className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                  />
                </div>
                <div className="grid gap-[6px]">
                  <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                    Designation <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="designation"
                    value={newExperienceForm.designation}
                    onChange={handleInputChange}
                    className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <CustomDropdown
                    label="Start Month"
                    value={newExperienceForm.startDateMonth}
                    onChange={handleInputChange}
                    options={months}
                    name="startDateMonth"
                  />
                  <CustomDropdown
                    label="Start Year"
                    value={newExperienceForm.startDateYear}
                    onChange={handleInputChange}
                    options={years}
                    name="startDateYear"
                  />
                </div>
                <div className="grid gap-[6px] mt-[-10px]">
                  <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5 w-[100px]">
                    <input
                      type="checkbox"
                      name="isCurrentJob"
                      checked={newExperienceForm.isCurrentJob}
                      onChange={handleInputChange}
                      className="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                    />
                    Current Job
                  </label>
                </div>

                {!newExperienceForm.isCurrentJob && (
                  <div className="grid grid-cols-2 gap-4">
                    <CustomDropdown
                      label="End Month"
                      value={newExperienceForm.endDateMonth}
                      onChange={handleInputChange}
                      options={months}
                      name="endDateMonth"
                    />
                    <CustomDropdown
                      label="End Year"
                      value={newExperienceForm.endDateYear}
                      onChange={handleInputChange}
                      options={years}
                      name="endDateYear"
                    />
                  </div>
                )}
                <JobWorkplaceTypeListbox
                  value={workplaceType}
                  onChange={handleWorkplaceTypeChange}
                />
                <div className="grid gap-[6px]">
                  <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                    Location
                  </label>
                  <JobEduLocationModal
                    items={locations}
                    buttonText="Search by city, state, or country"
                    onChange={handleLocationChange}
                    selectedItem={selectedCountry}
                    isLoading={loadingLocation}
                  />
                </div>
                <div className="grid gap-[6px]">
                  <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                    Description
                  </label>
                  <textarea
                    id="description"
                    name="description"
                    rows={4}
                    onChange={handleInputChange}
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                    value={newExperienceForm.description}
                  />
                </div>
              </div>

              <div className="flex justify-end gap-4 mt-5">
                <button
                  className="rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  <div className="flex items-center gap-[6px]">
                    Save
                    {isLoading && (
                      <div className="simple-spinner">
                        <span></span>
                      </div>
                    )}
                  </div>
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      {/* education  */}

      <Dialog
        open={isModalOpenEdu}
        onClose={setIsModalOpenEdu}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <h3 className="text-base font-semibold leading-6 text-gray-900">
                Add New Education
              </h3>
              <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setIsModalOpenEdu(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon aria-hidden="true" className="size-6" />
                </button>
              </div>
              <div className="grid gap-4 py-4 mt-1">
                <div className="grid gap-[6px]">
                  <label
                    htmlFor="course"
                    className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                  >
                    Course <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="course"
                    name="course"
                    value={newEducationForm?.course}
                    onChange={handleInputChangeEducation}
                    className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                          duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                         dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                  />
                </div>
                <div className="grid gap-[6px]">
                  <label
                    htmlFor="course"
                    className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                  >
                    University
                  </label>
                  <input
                    id="university"
                    name="university"
                    value={newEducationForm?.university}
                    onChange={handleInputChangeEducation}
                    className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                          duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                         dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="grid gap-[6px]">
                    <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                      Start Date
                    </label>
                    <div className="grid grid-cols-2 gap-2">
                      <CustomDropdown
                        value={newEducationForm.start_month}
                        onChange={handleInputChangeEducation}
                        options={months}
                        name="start_month"
                        placeholder="Month"
                      />
                      <CustomDropdown
                        value={newEducationForm.start_year}
                        onChange={handleInputChangeEducation}
                        options={years}
                        name="start_year"
                        placeholder="Year"
                      />
                    </div>
                  </div>
                  <div className="grid gap-[6px]">
                    <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                      End Date
                    </label>
                    <div className="grid grid-cols-2 gap-2">
                      <CustomDropdown
                        value={newEducationForm.end_month}
                        onChange={handleInputChangeEducation}
                        options={months}
                        name="end_month"
                        placeholder="Month"
                      />
                      <CustomDropdown
                        value={newEducationForm.end_year}
                        onChange={handleInputChangeEducation}
                        options={years}
                        name="end_year"
                        placeholder="Year"
                      />
                    </div>
                  </div>
                </div>
                <div className="grid gap-[6px]">
                  <label
                    htmlFor="course"
                    className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                  >
                    Location
                  </label>
                  <JobEduLocationModal
                    items={locations}
                    buttonText="Search by city, state, or country"
                    onChange={handleLocationChangeEdu}
                    selectedItem={selectedCountryEdu}
                    isLoading={loadingLocationEdu}
                  />
                </div>
                <div className="grid gap-[6px]">
                  <label
                    htmlFor="course"
                    className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                  >
                    Specialization
                  </label>
                  <input
                    id="branch"
                    name="branch"
                    value={newEducationForm?.branch}
                    onChange={handleInputChangeEducation}
                    className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                          duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                         dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                  />
                </div>
                <div className="grid gap-[6px]">
                  <label
                    htmlFor="course"
                    className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                  >
                    Grade
                  </label>
                  <input
                    id="grade"
                    name="grade"
                    type="text"
                    value={newEducationForm.grade}
                    onChange={handleInputChangeEducation}
                    className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                           duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                          dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                  />
                </div>
                <div className="grid gap-[6px]">
                  <label
                    htmlFor="description"
                    className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                  >
                    Description
                  </label>
                  <textarea
                    id="description"
                    name="description"
                    rows={4}
                    value={newEducationForm?.description}
                    onChange={handleInputChangeEducation}
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-4 mt-5">
                <button
                  className="rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  onClick={() => setIsModalOpenEdu(false)}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmitEdution}
                  className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  <div className="flex items-center gap-[6px]">
                    Save
                    {isLoadingEdu && (
                      <div className="simple-spinner">
                        <span></span>
                      </div>
                    )}
                  </div>
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
}

export default ReviewOverview;
